<template>
  <BaseInputWrapper v-if="$features.has('has_team_workspaces')">
    <template #label>
      <div class="field-heading q-mb-sm">{{ $t("global.team") }}</div>
    </template>
    <template #control>
      <BaseInputSelect
        v-model="organisationTeam"
        :disabled="disabled"
        new-design
        option-label="name"
        :options="filteredOptions"
        :placeholder="placeholder"
        :validations="validations"
      >
        <template #beforeOptions>
          <BaseInputText
            v-model="filter"
            clearable
            new-design
            :placeholder="$t('global.search')"
            tabindex="-1"
            @click.stop
          >
            <template #prepend>
              <BaseImageIcon
                class="q-pl-sm text-ds-denim-4"
                fallback-icon="ion-search"
              />
            </template>
          </BaseInputText>
        </template>
      </BaseInputSelect>
    </template>
  </BaseInputWrapper>
</template>

<script>
import { getLocaleText } from "shared/boot/i18n";
import {
  BaseImageIcon,
  BaseInputText,
  BaseInputWrapper,
} from "shared/components/base";
import BaseInputSelect from "shared/components/base/BaseInputSelect";
import useTeamPicker from "shared/composables/useTeamPicker";

export default {
  name: "TeamSelector",
  components: {
    BaseInputWrapper,
    BaseInputText,
    BaseImageIcon,
    BaseInputSelect,
  },
  props: {
    modelValue: {
      type: [Number, String],
      default: null,
    },
    disabled: {
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: () => getLocaleText("global.team"),
    },
    validations: {
      type: Array,
      default: () => [],
    },
    isSearch: {
      type: Boolean,
    },
    excludeAllOption: {
      type: Boolean,
    },
  },
  emits: ["update:modelValue"],
  setup() {
    const { organisationTeamOptions, isUserRoleSuper } = useTeamPicker();

    return {
      organisationTeamOptions,
      isUserRoleSuper,
    };
  },
  data() {
    return {
      filter: null,
    };
  },
  computed: {
    organisationTeam: {
      get() {
        const value = this.modelValue === null ? null : Number(this.modelValue);

        return this.options.find(({ id }) => id === value);
      },
      set(value) {
        this.$emit("update:modelValue", value?.id);
      },
    },
    options() {
      if (this.excludeAllOption) return this.organisationTeamOptions;

      return [
        {
          name: this.$t("team_selector.all_teams"),
          id: null,
          disabled: !this.isUserRoleSuper && !this.isSearch,
        },
      ].concat(this.organisationTeamOptions);
    },
    filteredOptions() {
      if (!this.filter) return this.options;

      return this.options.filter(({ name }) =>
        name.toLowerCase().includes(this.filter.toLowerCase())
      );
    },
  },
};
</script>
